import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";

function ManagementMobile({ app, config }) {
  const { container } = config.management;

  return (
    <div className="app management">
      <div className="appContent">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[0].cards[0].nativeObject.id}
            header={{
              hardTitle: container[0].cards[0].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[0].cards[0].nativeObject.id}
              reference={{
                id: container[0].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            app={app}
            style={{
              width: "100%",
              alignItems: "center",
              height: "20%",
            }}
          >
            <NativeObject
              app={app}
              key={container[3].cards[0].nativeObject.id}
              reference={{
                id: container[3].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            app={app}
            style={{
              width: "100%",
              alignItems: "center",
              height: "20%",
            }}
          >
            <NativeObject
              app={app}
              key={container[3].cards[1].nativeObject.id}
              reference={{
                id: container[3].cards[1].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[1].cards[0].nativeObject.id}
            header={{
              hardTitle: container[1].cards[0].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[1].cards[0].nativeObject.id}
              reference={{
                id: container[1].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[1].cards[1].nativeObject.id}
            header={{
              hardTitle: container[1].cards[1].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[1].cards[1].nativeObject.id}
              reference={{
                id: container[1].cards[1].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[1].cards[2].nativeObject.id}
            header={{
              hardTitle: container[1].cards[2].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[1].cards[2].nativeObject.id}
              reference={{
                id: container[1].cards[2].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            height: "100%",
            paddingBottom: "20px",
          }}
        >
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[2].cards[0].nativeObject.id}
            header={{
              hardTitle: container[2].cards[0].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[2].cards[0].nativeObject.id}
              reference={{
                id: container[2].cards[0].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[2].cards[1].nativeObject.id}
            header={{
              hardTitle: container[2].cards[1].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[2].cards[1].nativeObject.id}
              reference={{
                id: container[2].cards[1].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
          <Card
            expandable
            exportTable
            app={app}
            exportContainer
            exportTableId={container[2].cards[2].nativeObject.id}
            header={{
              hardTitle: container[2].cards[2].title.hardTitle,
            }}
            style={{
              width: "100%",
              alignItems: "center",
              height: "50%",
            }}
          >
            <NativeObject
              app={app}
              key={container[2].cards[2].nativeObject.id}
              reference={{
                id: container[2].cards[2].nativeObject.id,
              }}
              style={{ marginTop: "20px" }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
}

ManagementMobile.defaultProps = {
  app: null,
  config: {},
};

ManagementMobile.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ManagementMobile;
